import { createSlice } from "../helper";
import * as ObjectExtensions from "../../utils/CoreExtensions/ObjectExtensions";
import { MeetingConstants } from "../../components/specific/Meeting/templates/constants";

//  Structure:
  // data: {
  //   content: {
  //     repeatMeetingSelectOptions: [{label: , value: {}}, ...],
  //     repeatMeetingSelectOptionsValue: {label: , value: {}},
  //     repeatsByMonthSelectOptions: [{label: , value: {}}, ...],
  //     meetingCustomRecurrenceModalData: {},
  //   },
  //   submitPayload: {
  //     topic: ,
  //     description: ,
  //     isPollMeeting: ,
  //     date: ,
  //     startTimeOfDay: ,
  //     EndTimeOfDay: ,
  //     recurrent: ,
  //     scheduleRule: ,
  //     repeatEvery: ,
  //     repeatsOnWeek: [weekNumbers],
  //     repeatsByMonthDate: ,
  //     repeatsEndDate: ,
  //     pollProposedSlots: {"0": {eventId: , date: , startTime: , endTime}, ...},
  //     meetingMode: {
  //       code: ,
  //       label: ,
  //       value:
  //     },
  //     participants: {
  //       selected: [selectedParticipants],
  //       isSelected: Boolean ,
  //       latestChange: []
  //     },
  //     autoAddMembersToMeeting: Boolean,
  //   }
  //   validityInfo: {
  //     isTopicValid: ,
  //     isMeetingModeValid: ,
  //     areProposedSlotsValid: ,
  //     isParticipantsValid: ,
  //   }
  // },
  // responsiveFormDetails: {
  //   detailsPaneClass: ,
  //   calendarPaneClass: ,
  //   isOnlyCalendarShown: Boolean
  // }

const initialState = {
  data: {},
  calendarDetails: {},
  responsiveFormDetails: {
    detailsPaneClass: 'd-block',
    calendarPaneClass: 'd-none d-md-block',
    isOnlyCalendarShown: false
  },
  suggestedSlotsDetails: {}
}

const meetingFormSlice = createSlice({
  name: 'MeetingForm',
  initialState: initialState,
  reducers: {
    setResponsiveFormDetails: (state, action) => {
      state.responsiveFormDetails = action.payload;
    },
    setCalendarDetails: (state, action) => {
      state.calendarDetails = action.payload;
    },
    setData: (state, action) => {
      state.data = action.payload;
    },
    updateContentData: (state, action) => {
      state.data.content = ObjectExtensions.deepMerge(state.data.content, action.payload);
    },
    updateSubmitPayloadData: (state, action) => {
      state.data.submitPayload = ObjectExtensions.deepMerge(state.data.submitPayload, action.payload);
    },
    updateValidityInfoData: (state, action) => {
      state.data.validityInfo = ObjectExtensions.deepMerge(state.data.validityInfo, action.payload);
    },
    updateSubmitPayloadMeetingData: (state, action) => {
      const recurrenceFields = ['recurrent', 'scheduleRule', 'repeatEvery', 'repeatsOnWeek', 'repeatsByMonthDate', 'repeatsEndDate'];
      const hasRecurrenceFields = recurrenceFields.some(field => action.payload[field] !== undefined);
      const currentDate = state.data.submitPayload?.meeting?.date;
      const isRecurrenceEditable = !state.data.submitPayload?.meeting?.occurrenceId;
      const isRecurrent = state.data.submitPayload?.meeting?.recurrent;

      let hasDateChanged = action.payload.date && (
        !currentDate ||
        (() => {
          try {
            return new Date(action.payload.date).toDateString() !== new Date(currentDate).toDateString();
          } catch (e) {
            return action.payload.date !== currentDate;
          }
        })()
      );

      const isNotDailyRecurrence = state.data.submitPayload?.meeting?.scheduleRule !== MeetingConstants.Repeats.DAILY;
      const shouldResetRecurrence = isRecurrenceEditable && isRecurrent && hasDateChanged && !hasRecurrenceFields && isNotDailyRecurrence;

      if (shouldResetRecurrence) {
        state.data.submitPayload.meeting = ObjectExtensions.deepMerge(
          state.data.submitPayload.meeting || {},
          ObjectExtensions.deepMerge({ recurrent: false }, action.payload)
        );

        if (state.data.content) {
          state.data.content.repeatMeetingSelectOptionsValue = null;
          state.data.content.shouldOpenRepeatSelect = true;
        }
      } else {
        state.data.submitPayload.meeting = ObjectExtensions.deepMerge(
          state.data.submitPayload.meeting || {},
          action.payload
        );
      }
    },
    updateDescriptionAfterSuggestedSlotSelection: (state, action) => {
      const existingDescription = state.data.submitPayload.meeting.description;
      state.data.submitPayload.meeting.description = `${action.payload.prependText} \n ${existingDescription}`;
    },
    updateSubmitPayloadMeetingPollData: (state, action) => {
      state.data.submitPayload.meeting.meetingPoll = ObjectExtensions.deepMerge(state.data.submitPayload.meeting.meetingPoll, action.payload);
    },
    setPollProposedSlotsData: (state, action) => {
      state.data.submitPayload.meeting.meetingPoll.pollProposedSlots = action.payload.pollProposedSlots;
      state.data.validityInfo.arePollProposedSlotsValid = action.payload.arePollProposedSlotsValid;
      state.data.content.arePollProposedSlotsChangedOnCalendar = action.payload.arePollProposedSlotsChangedOnCalendar;
    },
    setRepeatMeetingContentData: (state, action) => {
      state.data.content.repeatMeetingSelectOptions = action.payload.repeatMeetingSelectOptions;
      state.data.content.repeatMeetingSelectOptionsValue = action.payload.repeatMeetingSelectOptionsValue;
      state.data.content.shouldOpenRepeatSelect = action.payload.shouldOpenRepeatSelect;
      state.data.content.repeatsByMonthSelectOptions = action.payload.repeatsByMonthSelectOptions;
      state.data.content.customRecurrenceModalData = action.payload.customRecurrenceModalData;
    },
    updateShowMonthlyRecurrentMeetingNote: (state, action) => {
      if (action.payload !== undefined) {
        state.data.content.showMonthlyRecurrentMeetingNote = action.payload;
      }
    },
    updateSuggestedSlotsDetails: (state, action) => {
      state.suggestedSlotsDetails = action.payload.reset ? {} : ObjectExtensions.deepMerge(state.suggestedSlotsDetails, action.payload);
    },
    updateCanShowConnectCalendarBannerPostSlotFetched: (state, action) => {
      if (state.data.content.calendarConnectBannerDetails) {
        state.data.content.calendarConnectBannerDetails.canShowConnectCalendarBannerPostSlotFetched = action.payload;
      }
    }
  }
});

export const meetingFormActions =  meetingFormSlice.actions;

export default meetingFormSlice;
